import React from "react";
import {
    Dimmer,
    Loader,
    Segment,
} from "semantic-ui-react";

const LoadingSegment = ({text}) =>
    <Segment style={{minHeight: "10em"}}>
        <Dimmer active inverted>
            <Loader size="large">{text}</Loader>
        </Dimmer>
    </Segment>;

export default LoadingSegment



// WEBPACK FOOTER //
// ./src/util/LoadingSegment.js